export enum LeadTimePeriod {
  ANNUALLY = "annually",
  QUARTERLY = "quarterly",
  MONTHLY = "monthly",
  PERPETUAL = "perpetual",
}
